import script from "./CodeEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./CodeEditor.vue?vue&type=script&setup=true&lang=js"

import "./CodeEditor.vue?vue&type=style&index=0&id=165a2517&lang=css"

const __exports__ = script;

export default __exports__